// Contenu structuré pour le site Destins de Femmes

export const siteContent = {
  // Navigation
  navigation: {
    logo: "Destins de Femmes",
    menu: [
      { label: "Accueil", href: "#home", id: "home" },
      { label: "L'ONG", href: "#about", id: "about" },
      { label: "Valérie Perez", href: "#founder", id: "founder" },
      { label: "Nos missions", href: "#missions", id: "missions" },
      { label: "Nos actions", href: "#actions", id: "actions" },
      { label: "La chaîne YouTube", href: "#youtube", id: "youtube" },
      { label: "Le livre", href: "#book", id: "book" },
      { label: "L'équipe", href: "#team", id: "team" },
      { label: "Nos partenaires", href: "#partners", id: "partners" },
      { label: "Contact", href: "#contact", id: "contact" }
    ]
  },

  // Page d'accueil
  hero: {
    title: "Destins de Femmes",
    subtitle: "d'un livre à une ONG, d'un cri à une mission.",
    description: "Porter la voix des femmes, inspirer des engagements concrets, et promouvoir un féminisme positif, humaniste et fédérateur.",
    cta: {
      primary: { text: "Découvrir l'ONG", href: "#about" },
      // secondary: { text: "Soutenir l'ONG", href: "#contact" }
    }
  },

  // L'ONG
  about: {
    title: "D'un livre à une ONG, d'un récit à une mission universelle",
    content: [
      "En 2021, Valérie Perez publie Destins de Femmes (Éditions Ramsay), un livre poignant regroupant 17 témoignages de femmes du monde entier. Fruit de 10 ans de rencontres, d'enquêtes et de voyages, cet ouvrage retrace la résilience, la douleur, la force intérieure, les combats et les rêves de ces femmes invisibles, mais essentielles.",
      "Récompensé par le Prix Edgar Faure, labellisé Génération Égalité Voices et ONU Femmes France 2023, ce livre devient bien plus qu'un projet littéraire : un manifeste.",
      "En 2024, Valérie Perez fonde l'ONG Destins de Femmes pour prolonger l'impact du livre dans la vie réelle. L'objectif ? Porter la voix des femmes, inspirer des engagements concrets, et promouvoir un féminisme positif, humaniste et fédérateur."
    ],
    awards: [
      "Prix Edgar Faure",
      "Labellisé Génération Égalité Voices",
      "ONU Femmes France 2023"
    ]
  },

  // Fondatrice
  founder: {
    title: "Une plume, une voix, une femme engagée",
    name: "Valérie Perez",
    content: [
      "Valérie Perez est une journaliste, présentatrice et autrice française née le 8 janvier 1968 à Paris.",
      "Elle débute sur Nostalgie la télé avant de rejoindre Télé Lyon Métropole où elle présente OL Info et OL Zoom.",
      "De 1999 à 2005, elle présente le Journal des Sports sur i‑Télévision, Foot 3 sur France 3, chroniqueuse sur Stade 2 et présentatrice terrains sur France 2.",
      "Elle commente Roland Garros et anime Sport Week‑end sur France 2 en 2004.",
      "En 2013, elle rejoint i24News pour la quotidienne « Société » (2013–2016), puis devient journaliste et rédactrice en chef de « Histoires et Découvertes » en 2017.",
      "Autrice de « Destins de Femmes » (2021) et co‑auteure d’un ouvrage sur un héros du Mossad paru le 24 janvier 2023."
    ],
    experience: [
      "Nostalgie",
      "OL TV",
      "I-Television",
      "France Télévisions",
      "Canal",
      "MCE",
      "i24News"
    ]
  },

  // Missions
  missions: {
    title: "Notre raison d'être",
    list: [
      {
        title: "Promouvoir les droits des femmes",
        description: "À travers l'art, la culture et la transmission."
      },
      {
        title: "Démarche inclusive",
        description: "Inscrire les combats féminins dans une démarche inclusive, universelle et solidaire."
      },
      {
        title: "Mettre en lumière",
        description: "Des récits de femmes invisibilisées."
      },
      {
        title: "Associer les hommes",
        description: "Car l'égalité n'est pas une guerre de genre, mais une cause commune."
      },
      {
        title: "Sensibiliser et transformer",
        description: "Utiliser la parole, l'écoute, le théâtre, la vidéo, pour sensibiliser et transformer."
      },
      {
        title: "Créer des ponts interculturels",
        description: "Favoriser le dialogue et la compréhension entre les cultures à travers les témoignages universels."
      },
      // {
      //   title: "Inspirer la nouvelle génération",
      //   description: "Transmettre aux jeunes femmes et hommes les valeurs d'engagement, de courage et de solidarité pour bâtir un monde plus juste."
      // }
    ],
    cta: { text: "Découvrir nos actions concrètes", href: "#actions" }
  },

  // Actions
  actions: {
    title: "Des mots à l'action",
    timeline: [
      {
        date: "Octobre 2023",
        title: "Lecture théâtrale au Théâtre du Rond-Point, Paris",
        description: "Plus de 700 spectateurs",
        type: "event"
      },
      {
        date: "Été 2024",
        title: "Création officielle de l'ONG",
        description: "Lancement officiel de l'organisation",
        type: "milestone"
      },
      {
        date: "Septembre 2024",
        title: "Événement à Livry-Gargan",
        description: "Rencontre avec le public local",
        type: "event"
      },
      {
        date: "Décembre 2024",
        title: "Remise du prix Edgar Faure",
        description: "Reconnaissance officielle du travail accompli",
        type: "award"
      },
      {
        date: "Mars 2025",
        title: "Vente aux enchères caritative",
        description: "Collecte de fonds pour les actions de l'ONG",
        type: "fundraising"
      },
      {
        date: "Mars 2025",
        title: "Lancement de la chaîne YouTube Destins de Femmes",
        description: "Nouvelle plateforme de diffusion",
        type: "launch"
      },
      {
        date: "Juillet 2025",
        title: "Remise du Prix \"Destins de Femmes\"",
        description: "Premier prix décerné par l'ONG",
        type: "award"
      },
      {
        date: "Janvier 2026",
        title: "Sortie de « Destins de femmes combattantes » chez Fayard",
        description: "Le nouveau livre de Valérie Perez aux Éditions Fayard",
        type: "publication"
      }
    ]
  },

  // YouTube
  youtube: {
    title: "Des histoires vraies, des voix fortes",
    subtitle: "Une émission pour inspirer",
    description: "Chaque semaine sur YouTube, Valérie Perez reçoit une femme (ou un homme engagé) pour parler de vie, de résilience, de choix, de féminisme. Tournée dans un hôtel parisien, l'émission \"Destins de Femmes\" mêle confidences intimes, parcours inspirants et questionnements profonds.",
    cta: { text: "Voir tous les épisodes", href: "https://youtube.com/@destinsdefemmes" }
  },

  // Livre
  book: {
    title: "Un livre, des vies, un souffle",
    description: "Publié en 2021, Destins de Femmes raconte 17 histoires vraies. De la maternité en temps de guerre, aux luttes invisibles contre les diktats sociaux, ces récits sont autant de fenêtres sur la condition féminine dans le monde.",
    tome2: {
      title: "Destins de femmes combattantes",
      publisher: "Éditions Fayard",
      date: "Janvier 2026",
      description: "Le nouveau livre de Valérie Perez, « Destins de femmes combattantes », est paru en janvier 2026 aux Éditions Fayard.",
      cover: "/images/book/ddf2_cover.webp",
      buyLink: "https://www.fnac.com/a22086718/Valerie-Perez-Destins-de-femmes-combattantes",
      presentationVideo: "https://www.instagram.com/reel/DUvZhFQiGFu/"
    }
  },

  // Galerie (épisodes YouTube)
  gallery: [
    {
      youtubeUrl: "https://www.youtube.com/embed/52t2bl3sV7Y",
      title: "PASCAL ELBÉ"
    },
    {
      youtubeUrl: "https://www.youtube.com/embed/-pC-UyYVwSY",
      title: "IMAM CHALGOUMI"
    },
    {
      youtubeUrl: "https://www.youtube.com/embed/d-Lu2qUmEPw",
      title: "ELIE DE ROTHSCHILD"
    },
    {
      youtubeUrl: "https://www.youtube.com/embed/b6ByH_i1MPQ",
      title: "DAVID BENAYM – La vérité à cœur ouvert"
    },
    {
      youtubeUrl: "https://www.youtube.com/embed/oyuDlJ57CP0",
      title: "MARIE-CHRISTINE DUPUIS-DANON : femme de l'ombre, actrice du monde"
    },
    {
      youtubeUrl: "https://www.youtube.com/embed/4WeqHf40OrA",
      title: "EMMANUEL PETIT : l'homme derrière le footballeur"
    },
    {
      youtubeUrl: "https://www.youtube.com/embed/psKzTOGVbEQ",
      title: "CAROLINE FOUREST : Itinéraire d'une femme libre"
    },
    {
      youtubeUrl: "https://www.youtube.com/embed/uceMo9JTHAQ",
      title: "MONA JAFARIAN – Femme, vie, liberté"
    },
    {
      youtubeUrl: "https://www.youtube.com/embed/LlGr2vJDgwY",
      title: "CATHERINE DIAMENT : scénariste passionnée"
    },
  ],

  // Vidéos Instagram / Réseaux sociaux
  instagramReels: [
    {
      url: "https://www.instagram.com/reel/DUvZhFQiGFu/",
      title: "Présentation du nouveau livre – Destins de femmes combattantes",
      type: "book-presentation"
    },
    {
      url: "https://www.instagram.com/reel/DUgZjYaAXtA/",
      title: "Interview i24",
      type: "interview"
    },
    {
      url: "https://x.com/christine_kelly/status/2026639199579869203",
      title: "Valérie Perez sur Europe 1 avec Christine Kelly",
      type: "twitter"
    }
  ],

  // Équipe (format pour le composant fourni)
  teamData: [
    {
      name: "Valérie Perez",
      job: "Fondatrice / Présidente",
      img: "/images/team/valerie-perez.jpg",
      url: "https://valerieperezennouchi.com/"
    },
    {
      name: "Sacha Perez",
      job: "Photographe / Filmmaker",
      img: "/images/team/sacha-perez.jpg",
      url: "https://www.instagram.com/mynameissacha/?hl=fr"
    },
    {
      name: "Jordan Perez",
      job: "Développeur",
      img: "/images/team/jordan-perez.jpg",
      url: "https://jordanperez.dev/"
    },
    {
      name: "Olivia Goldman",
      job: "Directrice de la communication",
      img: "/images/team/olivia-goldman.jpg",
      url: "https://ogoldman.com/"
    },
    {
      name: "Mathilde Farges",
      job: "Attachée de presse",
      img: "/images/team/mathilde-farges.jpg",
      url: "https://ogoldman.com/"
    }
  ],

  // Contact (format pour le composant fourni)
  contactData: {
    facebook: "https://facebook.com/destinsdefemmes",
    instagram: "https://instagram.com/destinsdefemmes",
    youtube: "https://youtube.com/@destinsdefemmes"
  },

  // Équipe
  team: {
    title: "L'équipe",
    members: [
      {
        name: "Valérie Perez",
        role: "Fondatrice",
        bio: "Créé l'ONG après avoir écrit Destins de Femmes pour continuer à diffuser le message du livre.",
        image: "/images/team/valerie-perez.jpg"
      },
      {
        name: "Sacha Perez",
        role: "Photographe et vidéaste",
        bio: "Capture la beauté des rencontres et des événements avec un regard artistique et engagé.",
        image: "/images/team/sacha-perez.jpg"
      },
      {
        name: "Jordan Perez",
        role: "Développeur",
        bio: "Conçoit les outils numériques de l'ONG pour renforcer notre rayonnement.",
        image: "/images/team/jordan-perez.jpg"
      },
      {
        name: "Olivia Goldman",
        role: "Directrice de la communication",
        bio: "Pilote les relations presse, l'identité digitale et les partenariats stratégiques.",
        image: "/images/team/olivia-goldman.jpg"
      },
      {
        name: "Mathilde Farges",
        role: "Attachée de presse",
        bio: "Fait rayonner l'ONG dans les médias et veille à chaque prise de parole.",
        image: "/images/team/mathilde-farges.jpg"
      }
    ]
  },

  // Contact
  contact: {
    title: "Contactez-nous",
    form: {
      name: { label: "Nom", placeholder: "Votre nom complet" },
      email: { label: "Email", placeholder: "votre@email.com" },
      message: { label: "Message", placeholder: "Votre message..." },
      submit: "Envoyer le message"
    },
    info: {
      address: "2 Rue Barye, 75017, Paris, France",
      phone: "+33 06 55 55 55 55",
      email: "valerie@destinsdefemmes.com"
    },
    social: {
      title: "Suivez-nous sur les réseaux sociaux",
      links: [
        { name: "Instagram", url: "https://instagram.com/destinsdefemmes", icon: "instagram" },
        { name: "YouTube", url: "https://youtube.com/@destinsdefemmes", icon: "youtube" },
        { name: "LinkedIn", url: "https://linkedin.com/company/destinsdefemmes", icon: "linkedin" },
        { name: "TikTok", url: "https://tiktok.com/@destinsdefemmes", icon: "tiktok" }
      ]
    }
  },

  // Footer
  footer: {
    copyright: "© 2024 Destins de Femmes. Tous droits réservés.",
    partners: {
      title: "Nos partenaires",
      logos: [
        { name: "Renoma", image: "/images/partners/renoma.png" },
        { name: "Maison XXL", image: "/images/partners/maison-xxl.png" },
        { name: "Hôtel Scribe", image: "/images/partners/hotel-scribe.png" }
      ]
    }
  }
};

export default siteContent;

